import styled from 'styled-components';
import { THEME } from '../../../../../themes';
import { Subtitle1Font, Title3Font } from '../../../../../themes/fonts';
import { ReactComponent as LOCK } from '../../../../../assets/lock.svg';

import DOTED_CIRCLE from '../../../../../assets/doted-circle.svg';
import { shakeAnimation } from '../../../../../animations';
import { ASSETS } from '../../../../../assets';
import { lowElevation } from '../../../../../themes/elevations';

export const Card = styled.div`
  ${lowElevation};
  width: 424px;
  margin-top: ${THEME.SPACING.LOOSE};
  position: relative;
  padding: ${THEME.SPACING.LOOSE};
  border-radius: ${THEME.RADIUS.CURVY};
  border: solid 1px ${THEME.COLORS_RGB.PRIMARY_DIVIDER};
  background-color: ${THEME.COLORS.SURFACE_PRIMARY};
  animation: ${shakeAnimation({
    animationDuration: 500,
    animationDelay: 1000,
  })
};
  overflow: hidden;
`;

export const HorizontalDivider = styled.div`
  position: absolute;
  top: -5px;
  left: 0;
  height: 100%;
  width: 4px;
  background-color: ${THEME.COLORS.WARNING};
`;

export const Title = styled.div`
  ${Title3Font};
  font-weight: 600;
  margin-top: ${THEME.SPACING.BASE};
  color: ${THEME.COLORS.CONTENT_A};
`;

export const Description = styled.div`
  ${Subtitle1Font};
  margin-top: ${THEME.SPACING.XLARGE};
  opacity: ${THEME.OPACITY.MED};
  color: ${THEME.COLORS.CONTENT_A};
`;

export const FooterContainer = styled.div`
  margin-top: ${THEME.SPACING.MEDIUM};
  display: flex;
  justify-content: space-between;
`;

export const IconWrapper = styled.div`
  width: 55px;
  height: 55px;
  padding: 10px;
  border-radius: ${THEME.RADIUS.CIRCLE};
  background-image: url(${DOTED_CIRCLE});
  background-color: ${THEME.COLORS_RGB.YELLOW_012};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LockIcon = styled(LOCK)`
  fill: ${THEME.COLORS.WARNING};
  width: 16.6px;
  height: 24px;
`;

export const EngageOrDeclineIcon = styled(ASSETS.ENGAGE_OR_DECLINE)`
  fill: ${THEME.COLORS.PRIMARY_DARK};
  width: ${THEME.SPACING.LOOSE};
  height: 20.3px;
`;
